import { render, staticRenderFns } from "./WriteMailModal.vue?vue&type=template&id=b8b0bb72&scoped=true&"
import script from "./WriteMailModal.vue?vue&type=script&lang=js&"
export * from "./WriteMailModal.vue?vue&type=script&lang=js&"
import style0 from "./WriteMailModal.vue?vue&type=style&index=0&id=b8b0bb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b0bb72",
  null
  
)

export default component.exports